"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerativeContentReasonId = exports.GenerativeContentReasonId_ReasonId = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** Enum of accepted feedback reasons. */
var GenerativeContentReasonId_ReasonId;
(function (GenerativeContentReasonId_ReasonId) {
    /** UNSET - Unset. */
    GenerativeContentReasonId_ReasonId[GenerativeContentReasonId_ReasonId["UNSET"] = 0] = "UNSET";
    /** DONT_LIKE - User doesnt like the generated asset. */
    GenerativeContentReasonId_ReasonId[GenerativeContentReasonId_ReasonId["DONT_LIKE"] = 1] = "DONT_LIKE";
    /** INAPPROPRIATE - User finds generated content offensive. */
    GenerativeContentReasonId_ReasonId[GenerativeContentReasonId_ReasonId["INAPPROPRIATE"] = 2] = "INAPPROPRIATE";
    GenerativeContentReasonId_ReasonId[GenerativeContentReasonId_ReasonId["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(GenerativeContentReasonId_ReasonId = exports.GenerativeContentReasonId_ReasonId || (exports.GenerativeContentReasonId_ReasonId = {}));
function createBaseGenerativeContentReasonId() {
    return { reasonId: 0 };
}
exports.GenerativeContentReasonId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.reasonId !== 0) {
            writer.uint32(8).int32(message.reasonId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGenerativeContentReasonId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.reasonId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseGenerativeContentReasonId();
        message.reasonId = object.reasonId ?? 0;
        return message;
    },
};
//# sourceMappingURL=generative_content_reason_id.js.map